import {loadStripe}  from '@stripe/stripe-js';
import {inject, ref} from "vue";
import cloneSet      from "lodash-es/_cloneSet";
export default function useStripe ()
{

    let stripe = ref(null);
    let paymentIntent = ref(null);
    let cardNumber = ref(null);
    let cardExpiry = ref(null);
    let cardCvc = ref(null);

    async function activate (strSelectorNumber, strSelectorExpiry, strSelectorCvc)
    {
        let pk_stripe = inject('pk_stripe');
        stripe.value = await loadStripe(pk_stripe);

        let elements = stripe.value.elements();

        cardNumber.value = elements.create("cardNumber", {
            showIcon:    true,
            style: elementStyles,
            placeholder: "Numéro de carte de crédit"
        });

        cardNumber.value.mount(strSelectorNumber);

        cardExpiry.value = elements.create("cardExpiry", {
            style: elementStyles,
            placeholder: "mm/aa"
        });

        cardExpiry.value.mount(strSelectorExpiry);

        cardCvc.value = elements.create("cardCvc", {
            style: elementStyles
        });

        cardCvc.value.mount(strSelectorCvc);


    }


    async function createIntent (amount)
    {
        let response = await fetch("/endpoints/stripe-create-intent", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                amount
            })
        });

        paymentIntent.value = await response.json();

        return paymentIntent.value;
    }

    async function process (firstname, lastname)
    {
        let cs   = { clientSecret : paymentIntent.value.cs };

        console.log("cs", cs);

        let elements = stripe.value.elements( cs )


        let payload = {
            payment_method :
                {
                    card : cardNumber.value,

                    billing_details :
                        {
                            name : firstname + " " + lastname,

                        },
                    metadata        :
                        {
                            description : "TODO #",
                        },
                },
        };

        try
        {
            const stripeConfirmation = await stripe.value.confirmCardPayment( paymentIntent.value.cs, payload );

            console.log("stripeConfirmation", stripeConfirmation);

            if ( stripeConfirmation.error )
            {

                return stripeConfirmation;
            }


            return stripeConfirmation;
        }
        catch (e)
        {
            console.log( "confirm catch", e );
            return false;
        }
    }

    function getErrorFromStripe (error, copydeck)
    {
        let code = `stripe_error_${error.code}`;

        console.log(code);

        let message = copydeck[code].fr ?? 'Impossible de traiter le paiement. Veuillez réessayer plus tard. ' + code;

        let category = "credit-card-number";

        if (["invalid_expiry_year_past"].includes(error.code))
        {
            category = "credit-card-expiry-date";

        }
        else if (["incorrect_cvc"].includes(error.code))
        {
            category = "credit-card-ccv";
        }

        return {message, code: error.code, category};
    }
    let elementStyles = {
        base: {
            color: '#161616',
            fontWeight: 400,
            fontFamily: 'PT Sans,sans-serif',
            fontSize: '16px',
            textAlign: 'left',
            lineHeight: '1.2',
            fontSmoothing: 'antialiased',

            '::placeholder': {
                color: '#161616',
            },
            ':-webkit-autofill': {
                color: '#161616',
            },
        },
        invalid: {
            color: '#f63e3e',

            '::placeholder': {
                color: '#f63e3e',
            },
        },
    }

    return {
        activate,
        createIntent,
        process,

        getErrorFromStripe
    }
}
